/**
 * Récupère la liste officielle des 14 emplacements SESAM depuis /api/emplacements
 * et les groupe par type pour alimenter le composant DevisLignesMulti.
 *
 * Les emplacements du module Emplacement sont désormais la SOURCE DE VÉRITÉ
 * pour la création de devis / contrats. Plus de doublons via nos-panneaux.
 */
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL;

const normalizeType = (raw) => {
  const t = (raw || '').toLowerCase().trim();
  if (t.includes('poteau')) return 'Poteau';
  if (t.includes('led') || t.includes('digital')) return 'LED Digital';
  if (t.includes('dérou') || t.includes('derou')) return 'Déroulant';
  if (t.includes('grand') || t.includes('format')) return 'Grand Format';
  return raw || 'Autre';
};

// Capacité max d'affiches par emplacement — 25 pour poteau, 10 sinon
const capacityForType = (type, empDoc) => {
  if (type === 'Poteau') return Number(empDoc?.capacite_poteaux || 25);
  return Number(empDoc?.capacity ?? 10) || 10;
};

export async function fetchEmplacementsByType() {
  let emplacements = [];
  try {
    const { data } = await axios.get(`${API}/api/emplacements`);
    emplacements = Array.isArray(data) ? data : [];
  } catch {
    emplacements = [];
  }

  // Tri par numéro croissant pour une présentation cohérente
  emplacements.sort((a, b) => (a.numero || 999) - (b.numero || 999));

  const byType = { 'LED Digital': [], 'Déroulant': [], 'Grand Format': [], 'Poteau': [] };
  const all = [];
  const seenNames = new Set();

  for (const e of emplacements) {
    const nom = e.nom || '';
    if (!nom) continue;
    if (seenNames.has(nom)) continue; // dé-doublonnage strict
    seenNames.add(nom);
    const t = normalizeType(e.type_panneau);
    const numero = e.numero ? `#${e.numero} · ` : '';
    const capacity = capacityForType(t, e);
    const used = Number(e.used ?? 0) || 0;
    const available = Math.max(0, capacity - used);
    const label = `${numero}${nom}`;
    const item = {
      value: nom,
      label,
      type: t,
      emplacement_id: e.id,
      numero: e.numero,
      capacity,
      used,
      available,
      full: available <= 0,
      occupants: Array.isArray(e.occupants) ? e.occupants : [],
    };
    all.push(item);
    if (byType[t]) byType[t].push(item);
  }

  return { all, byType };
}
